import { Box } from "@mui/material"
import ChatExclamationIcon from '../../../../../../../../assets/svg/chat-exclamation.svg'
import { useStyles } from "./styles"


const InstructionComponent = (props: any) => {
    const styles = useStyles()
    let haveInstruction = props?.current ?? 0


    return (
        <Box sx={styles.container}>
            {haveInstruction ? <ChatExclamationIcon /> : null}
        </Box>
    )
}

export { InstructionComponent }